module.exports = __webpack_public_path__ + "img/Icon Wireless.55718c9d.png";